import CredentialedResource from "./credentialed-resource";
import ProfessionalProvider from "./professional-provider";
import Volunteer from "./volunteers/volunteer";

function isVolunteer(p: Volunteer | CredentialedResource): p is Volunteer {
  return p && p.resourceType === "5";
}

function isProfessionalProvider(
  p: ProfessionalProvider | CredentialedResource
): p is ProfessionalProvider {
  return p && p.resourceType === "1";
}

export {
  isVolunteer as isVolunteer,
  isProfessionalProvider as isProfessionalProvider,
};



// WEBPACK FOOTER //
// ./src/models/resource-management/company-resource-type-guards.ts